import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function SidebarBase({ storageKeyMenus, storageKeySubmenu, storageKeyLoc, storageKeyName }) {
  const [menus, setMenus] = useState([]);
  const [active, setActive] = useState(0);
  const [activeSub, setActiveSub] = useState(0);

  useEffect(() => {
    const menusLocal = window.localStorage.getItem(storageKeyMenus);
    const parentsOpenLocal = JSON.parse(window.localStorage.getItem("parents_open"));
    if (menusLocal) {
      let menusObject = JSON.parse(menusLocal);
      menusObject = menusObject.map((menuList) => ({
        ...menuList,
        open: parentsOpenLocal?.some((p) => p.menu.toString() === menuList.id_menu.toString()),
      }));
      setMenus(menusObject);
    }

    const submenu = window.localStorage.getItem(storageKeySubmenu);
    if (submenu) setActiveSub(JSON.parse(submenu));
  }, [storageKeyMenus, storageKeySubmenu]);

  const parentClick = (item) => {
    const updatedMenus = menus.map((menu) => ({
      ...menu,
      open: item.id_menu === menu.id_menu ? !menu.open : false,
    }));
    setMenus(updatedMenus);
    setActive(item.id_menu);

    window.localStorage.setItem(storageKeyMenus, JSON.stringify(updatedMenus));
    window.localStorage.setItem(
      "parents_open",
      JSON.stringify(updatedMenus.filter((m) => m.open).map((m) => ({ menu: m.id_menu })))
    );
  };

  const childrenClick = (list) => {
    setActiveSub(list.id_menu);
    window.localStorage.setItem(storageKeySubmenu, list.id_menu.toString());
    window.localStorage.setItem(storageKeyLoc, list.ruta);
    window.localStorage.setItem(storageKeyName, list.nombre);
  };

  return (
    <div className="sidebar row">
      <div className="column content-side">
        {menus.map((item) => (
          <React.Fragment key={item.id_menu}>
            <button
              className={`accordion color-white ${active === item.id_menu ? "active" : ""}`}
              onClick={() => parentClick(item)}
            >
              {item.parent_name}
              <i
                className={`fas fa-angle-left font-regular color-white icon-rotate ${
                  item.open ? "icon-down" : ""
                }`}
              ></i>
            </button>
            {item.recordset?.map((list) => (
              <div className={`panel ${item.open ? "maxHeight" : ""}`} key={list.id_menu}>
                <Link
                  to={list.ruta}
                  className={`row nav-item auto ${activeSub === list.id_menu ? "active-item" : ""}`}
                  onClick={() => childrenClick(list)}
                >
                  <div className="font-regular color-white">
                    <span className="color-white">{list.nombre}</span>
                  </div>
                </Link>
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default SidebarBase;
